import { render, staticRenderFns } from "./editGuidelinePanel.vue?vue&type=template&id=67623038&scoped=true&"
import script from "./editGuidelinePanel.vue?vue&type=script&lang=js&"
export * from "./editGuidelinePanel.vue?vue&type=script&lang=js&"
import style0 from "./editGuidelinePanel.vue?vue&type=style&index=0&id=67623038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67623038",
  null
  
)

export default component.exports